import { OfficeType } from '@core/constants';

export type CheckSheetType = 'tsusho' | 'nyusho';

export function getCheckSheetType(officeType: OfficeType): CheckSheetType {
  switch (officeType) {
    case OfficeType.oldNyusho:
    case OfficeType.newNyusho:
      return 'nyusho';
    case OfficeType.oldTsusho:
    case OfficeType.newTsusho:
    default:
      return 'tsusho';
  }
}
